import React, { useState } from 'react'
import { Link, Switch, Route, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown, Select as AntSelect, Menu, Drawer } from 'antd'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'
import { BiSelectMultiple } from 'react-icons/bi'

import RecordSpoilage from '../modals/recordspoilage'
import ModifyQuantity from '../modals/modifyquantity'
import RestockItem from '../modals/restockitem'
import RestockOpen from '../modals/restockOpen'
import DispenseItems from '../modals/dispenseItems'
import Receive from '../reusable/receive'
import EditInventoryItem from '../modals/editInventoryItem'

import { useToggle, useListData, usePet } from '../../modules'
import { addItemToAccQueue, clearAccQueue, removeAccItem } from '../../store/actions'
import ItemRequests from './itemRequests'
import ItemHistory from './itemHistory'

const { Option } = AntSelect

const Store = ({ store: storeName, path }) => {
    const { queue } = useSelector(state => state.accounting)
    
    const dispatch = useDispatch()

    const history = useHistory()

    const [selected, setSelected] = useState(null)
    const [string, setString] = useState('')
    const [store, setStore] = useState()

    // const { option, setOption, dropdown } = useDropDown(['Select', 'Delete', 'Renew'])

    const [restockModal, toggleRestockModal] = useToggle()
    const [modifyQuantityModal, toggleModifyQuantityModal] = useToggle()
    const [inventoryItemModal, toggleInventoryItemModal] = useToggle()
    const [spoilageModal, toggleSpoilageModal] = useToggle()
    const [dispenseModal, toggleDispenseModal] = useToggle()
    const [invEdit, toggleInvEdit] = useToggle()
    const [visible, toggleVisible] = useToggle(true)
    const [request, toggleRequest] = useToggle()
    const [selectMode, toggleSelectMode] = useToggle(queue.length > 0)

    const restock = itm => {
        setSelected(itm)
        toggleRestockModal()
    }

    const spoilage = itm => {
        setSelected(itm)
        toggleSpoilageModal()
    }

    const modifyQty = itm => {
        setSelected(itm)
        toggleModifyQuantityModal()
    }

    const edit = itm => {
        setSelected(itm)
        toggleInvEdit()
    }

    const chooseItem = itm => {
        let i = queue.findIndex(e => e.item._id === itm.item._id)
        if (i >= 0) {
            dispatch(removeAccItem(i))
        } else {
            setSelected(itm)
        }
    }

    const [
        { loading: invLoading, error: invError, fetch }, 
        { list: inventory = [] }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('inventory', {
        store: store?._id,
        string
    }, { notify: true, manual: true })

    const refresh = () => {
        fetch()
        navigate(1)
    }
    
    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }
    
    usePet('getStoreId', { name: storeName }, { notify: true, callback: ({ data }) => {
        if (data) {
            setStore(data)
            refresh()
        }
    } })

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refresh()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width="60%">
            <p className="font-extrabold text-3xl mb-0">Inventory</p>
            <ModifyQuantity
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleModifyQuantityModal}
                visible={modifyQuantityModal} />
            <RestockOpen
                store={store}
                onPerform={fetch}
                toggle={toggleInventoryItemModal}
                visible={inventoryItemModal} />
            <RestockItem
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleRestockModal}
                visible={restockModal} />
            <RecordSpoilage
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleSpoilageModal}
                visible={spoilageModal} />
            <DispenseItems
                store={store}
                onPerform={fetch}
                toggle={toggleDispenseModal }
                visible={ dispenseModal } />
            {
                invEdit &&
                <EditInventoryItem
                    onPerform={fetch}
                    item={ selected?.item }
                    toggle={toggleInvEdit }
                    visible={ invEdit } />
            }
            <div className="w-full mx-auto">
                <div className="flex justify-between items-center mb-8">
                    <input
                        onChange={ e => search(e.target.value) }
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-inv-item"
                        type="text"
                        placeholder="Type to search items" />
                    <div className="grid grid-flow-col sm:auto-cols-max items-center justify-center sm:justify-end gap-2">
                        {
                            queue.length > 0 ?
                            <Dropdown
                                overlay={
                                    <Menu>
                                        <Menu.Item onClick={ () => {
                                            dispatch(clearAccQueue())
                                            toggleSelectMode()
                                        } }>Deselect All</Menu.Item>
                                        <Menu.Item onClick={ toggleRequest }>Request Items</Menu.Item>
                                    </Menu>
                                }>
                                <button className="btn hisani-btn-green-light text-white">
                                    <span className="hidden xs:block mr-2">Actions ({ queue.length })</span>
                                    <AiOutlineDown />
                                </button>
                            </Dropdown>
                            :
                            <button onClick={ () => toggleSelectMode() } className="btn hisani-btn-green-light text-white">
                                <BiSelectMultiple style={{ color: "white" }} />
                                <span className="hidden xs:block ml-2">{ selectMode ? 'Deselect' : 'Select' }</span>
                            </button>
                        }
                    </div>
                </div>
                <Receive
                    error={invError}
                    loading={invLoading}
                    progress>
                    {
                        store ?
                            <div className="overflow-x-auto">
                                <Receive
                                    error={invError}
                                    loading={invLoading}
                                    progress>
                                    {
                                        inventory?.length > 0 ?
                                            <table className="table-auto w-full">
                                                {/* Table header */}
                                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                    <tr>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">No</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Item</div>
                                                            </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Category</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Quantity</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center"></div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {/* Table body */}
                                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                    {
                                                        inventory.map((rec, key) =>
                                                            <tr>
                                                                <td className="p-2">
                                                                    <div className="text-center">
                                                                        {
                                                                            selectMode ?
                                                                                <input
                                                                                    onChange={() => chooseItem(rec)}
                                                                                    checked={ queue.some(e => e.item._id === rec.item._id) }
                                                                                    type="checkbox"
                                                                                    className="form-checkbox cursor-pointer h-5 w-5" />
                                                                            :
                                                                                `${((page - 1) * limit) + key + 1}.`
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="">{rec.item.name}</div>
                                                                    {
                                                                        rec?.item?.code &&
                                                                        <p className="text-gray-500 text-xs italic">{rec?.item?.code}</p>
                                                                    }
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{rec.item.category}</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{rec.variations.reduce((total, variant) => total + variant.total, 0)} {rec.item.issuedIn}</div>
                                                                </td>
                                                                <td className="p-2 text-center">
                                                                    <Dropdown
                                                                        overlay={
                                                                            <Menu>
                                                                                <Menu.Item><Link className="text-gray-600 hover:text-gray-600" to={ `${path}/inventory/history/${rec?.item?._id }/${store?._id}` }>View History</Link></Menu.Item>
                                                                                <Menu.Item onClick={ () => spoilage(rec) }>Record Spoilage/Damage</Menu.Item>
                                                                            </Menu>
                                                                        }>
                                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        :
                                            <div className="w-full h-16 flex items-center justify-center">
                                                <p className="font-semibold text-base">No items were found</p>
                                            </div>
                                    }
                                </Receive>
                                { Paginate }
                            </div>
                        :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">Please select a store</p>
                            </div>
                    }
                </Receive>
                <Switch>
                    <Route path={ `${path}/inventory/history/:id/:store` }>
                        <ItemHistory path={ `${path}/inventory` } onClose={ refresh } />
                    </Route>
                </Switch>
            </div>
        </Drawer>
    )
}

export default Store